import { create } from 'zustand';

const useGameStore = create((set, get) => ({
  nearbyPOIs: [],
  allCityPOIs: [],
  cityViewMode: false,
  selectedPOI: null,
  currentCity: null,
  currentPosition: null,
  rewardModalData: null,
  missionCompleteData: null,
  badgeUnlockData: null,
  modalQueue: [],

  setNearbyPOIs: (pois) => set({ nearbyPOIs: pois }),
  setAllCityPOIs: (pois) => set({ allCityPOIs: pois }),
  toggleCityViewMode: () => set((state) => ({ cityViewMode: !state.cityViewMode })),
  markPOICollected: (poiId) => set((state) => ({
    nearbyPOIs: state.nearbyPOIs.map((poi) =>
      poi.id === poiId
        ? { ...poi, isVisited: true, collectedRecently: true, lastVisitedAt: new Date().toISOString() }
        : poi
    ),
    allCityPOIs: state.allCityPOIs.map((poi) =>
      poi.id === poiId
        ? { ...poi, isVisited: true, collectedRecently: true, lastVisitedAt: new Date().toISOString() }
        : poi
    ),
  })),
  selectPOI: (poi) => set({ selectedPOI: poi }),
  clearSelectedPOI: () => set({ selectedPOI: null }),
  setCurrentCity: (city) => set({ currentCity: city }),
  setCurrentPosition: (position) => set({ currentPosition: position }),

  openRewardModal: (data) => set({ rewardModalData: data }),
  openRewardSequence: ({ reward, missions = [], badges = [] }) => {
    const modalQueue = [
      ...missions.map((mission) => ({ type: 'mission', data: mission })),
      ...badges.map((badge) => ({ type: 'badge', data: badge })),
    ];
    set({ rewardModalData: reward, modalQueue });
  },
  closeRewardModal: () => {
    const [next, ...rest] = get().modalQueue;
    if (!next) return set({ rewardModalData: null, modalQueue: [] });
    if (next.type === 'mission') {
      return set({ rewardModalData: null, missionCompleteData: next.data, modalQueue: rest });
    }
    if (next.type === 'badge') {
      return set({ rewardModalData: null, badgeUnlockData: next.data, modalQueue: rest });
    }
    return set({ rewardModalData: null, modalQueue: rest });
  },

  openMissionComplete: (data) => set({ missionCompleteData: data }),
  closeMissionComplete: () => {
    const [next, ...rest] = get().modalQueue;
    if (next?.type === 'badge') return set({ missionCompleteData: null, badgeUnlockData: next.data, modalQueue: rest });
    return set({ missionCompleteData: null, modalQueue: rest });
  },

  openBadgeUnlock: (data) => set({ badgeUnlockData: data }),
  closeBadgeUnlock: () => {
    const [next, ...rest] = get().modalQueue;
    if (next?.type === 'badge') return set({ badgeUnlockData: next.data, modalQueue: rest });
    if (next?.type === 'mission') return set({ badgeUnlockData: null, missionCompleteData: next.data, modalQueue: rest });
    return set({ badgeUnlockData: null, modalQueue: rest });
  },
}));

export default useGameStore;
